const hasKeys = function(obj, keys){
  const foundKeys = keys.filter(key => obj.hasOwnProperty(key));
  return foundKeys.length === keys.length;
};

const hasAnyKey = function(obj, keys){
  const foundKeys = keys.filter(key => obj.hasOwnProperty(key));
  return foundKeys.length > 0;

}
module.exports = {
  hasKeys,
  hasAnyKey
};
